module.exports = __webpack_public_path__ + "img/4-white.5a229385.svg";